import React from 'react'

const ProductSold = React.lazy(() => import('pages/ProductSold/ProductSold'));

const ProductSoldRoutes = [
    {
        path: '/product-sold',
        exact: true,
        name: 'Quản lý sản phẩm bán ra',
        function: 'MD_PRODUCTSOLD_VIEW',
        component: ProductSold,
    }
]

export default ProductSoldRoutes;
